import HelpIconButton from "./HelpIconButton";

export function ModalHeader({
  nightMode,
  headerName,
  helpIconObjectName,
  centered = true,
}) {
  return (
    <div
      id="header"
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        backgroundColor: nightMode ? "#616161" : "#fae8ad",
        borderRadius: "5px",
        paddingRight: "2px",
      }}
    >
      {centered && <div></div>}
      <h3 style={{ marginLeft: "1vw", color: nightMode ? "white" : "black" }}>
        {headerName}
      </h3>
      <HelpIconButton objectname={helpIconObjectName} />
    </div>
  );
}
